const deepMerge = (target, source) => {
    if (typeof target !== 'object' || typeof source !== 'object')
        return source;
    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            if (typeof source[key] === 'object' && source[key] !== null && !Array.isArray(source[key])) {
                target[key] = deepMerge(target[key] || {}, source[key]);
            }
            else {
                target[key] = source[key];
            }
        }
    }
    return target;
};
export default deepMerge;
//# sourceMappingURL=deepMerge.js.map